import { ICellEditor, IGridColumnEditor } from './../SimpleGridLight';
import { IGridColumnEditorProperties } from './../Editors/GridEditors';
import { CheckBox } from './../../index';
import { GridColumn } from './../GridColumn';
import { GridRow } from './../GridRow';
import { RowCollection } from './../RowCollection';
import { GridCell } from './../GridCell';
import { safeDestroys } from '@Common/Core/Destroyable';

export class GridCheckBoxEditor implements IGridColumnEditor {
    private readonly prop: IGridColumnEditorProperties;
    private all: CheckBox;
    private column: GridColumn;

    constructor(prop?: IGridColumnEditorProperties) {
        this.prop = $.extend(
            {},
            {
                setAll: false,
                setAllValueChanged: $.noop
            },
            prop
        );
    }

    public getEditor(row: GridRow, column: GridColumn): ICellEditor {
        const cell = row.getCell(column);
        const chb = new CellCheckbox(row.getCell(column));
        if (this.prop.onCreateCellEditor) {
            this.prop.onCreateCellEditor(cell, chb);
        }
        return chb;
    }

    public buildEditorForAll(column: GridColumn) {
        if (!this.prop.setAll) {
            return;
        }
        column.tableColumn().addClass('visibleEditor');
        this.column = column;

        this.all = new CheckBox({
            blockElement: true,
            showCaption: false,
            css: {
                textAlign: 'center'
            }
        });
        this.all.onChange(value => {
            column.setValue(value);
            this.prop.setAllValueChanged(column, value);
        });
        this.all.getControl().prependTo(column.tableColumn());
        if (column.title() == '') {
            column.tableColumn().css('textAlign', 'center');
        }
    }

    public refreshAll(rows: RowCollection) {
        if (this.prop.setAll) {
            const array = rows.ToArray().filter(r => !r.getCell(this.column).readonly());
            const anyFalse = array.some(r => !r.getValue(this.column));
            this.all.value(!anyFalse && array.length > 0, { stopEvents: true });
        }
    }
}

export class CellCheckbox implements ICellEditor {
    public cell: GridCell;
    public inner: CheckBox;

    constructor(cell: GridCell) {
        this.cell = cell;
        cell.tableCell().addClass('visibleEditor');
    }

    public beginEdit() {
        this.cell.tableCell().removeClass('active');
    }

    public endEdit() {}

    public refresh() {
        if (!this.inner && this.cell.getRow().isRendered) {
            this.inner = new CheckBox({
                blockElement: true,
                showCaption: false,
                css: {
                    'text-align': 'center'
                }
            });
            this.inner.onChange(value => {
                this.cell.value(value);
            });
            this.inner.getControl().appendTo(this.cell.tableCell());
        }
        this.readonly(this.cell.readonly());
        this.inner && this.inner.value(this.cell.value(), { stopEvents: true });
    }

    private readonly(value: boolean) {
        this.inner && this.inner.readonly(value);
    }

    public isInActiveMode() {
        return false;
    }

    public destroy(): void {
        safeDestroys(this.inner);
    }
}
